import { INVESTOR_HISTORY_PAGE_TITLE } from "./historyModuleConfig";

export const FUNDRAISING_PROJECTS_LABEL = "Fundraising Projects";
export const FUNDED_PROJECTS_LABEL = "Funded Projects";
export const TRANSFERABLE_PROJECTS_LABEL = "Transferable Projects";
/** Funded holdings where investors may submit redemption requests (/investments/redemptions). */
export const REDEEMABLE_PROJECTS_LABEL = "Redeemable Projects";

/** Terminal projects fully redeemed to SSA / parent company (100% treasury ownership). */
export const REDEEMED_PROJECTS_LABEL = "Redeemed Projects";

/** Portfolio Overview — Investment Opportunities subsection for SSA-owned projects. */
export const REDEEMED_PROJECTS_PARENT_LABEL = REDEEMED_PROJECTS_LABEL;

/** Shares Management module root (Redeemable Projects tab → /investments/redemptions). */
export const SHARES_MANAGEMENT_MODULE = {
  id: "shares-management",
  label: "Shares Management",
  to: "/investments",
  prefix: "/investments",
};

export const INVESTOR_PORTFOLIO_OVERVIEW_LABEL = "Portfolio Overview";

export const INVESTOR_SIDEBAR_NAV = [
  { type: "link", to: "/dashboard/investor", label: INVESTOR_PORTFOLIO_OVERVIEW_LABEL, icon: "portfolio-overview" },
  { type: "link", to: "/wallet", label: "My wallet", icon: "wallet" },
  { type: "link", to: SHARES_MANAGEMENT_MODULE.to, label: SHARES_MANAGEMENT_MODULE.label, icon: "shares-management" },
  { type: "link", to: "/my-history/deposits", label: INVESTOR_HISTORY_PAGE_TITLE, icon: "reports" },
  { type: "link", to: "/notifications", label: "Notifications", icon: "notifications" },
];

export function isSharesManagementRoute(pathname) {
  const p = String(pathname || "");
  return p === SHARES_MANAGEMENT_MODULE.prefix || p.startsWith(`${SHARES_MANAGEMENT_MODULE.prefix}/`);
}

export function isSharesManagementHome(pathname) {
  const p = String(pathname || "");
  return p === SHARES_MANAGEMENT_MODULE.to;
}

export function isRedeemSharesRoute(pathname) {
  return String(pathname || "").startsWith("/investments/redemptions");
}

export function isTransferableProjectsRoute(pathname) {
  return String(pathname || "").startsWith("/investments/transfers");
}
